import { selectFeatureFlags } from 'core/userContext';
import { useQueryContext } from 'modules/billing/contexts/QueryContext';
import { useMetricInfo } from 'modules/billing/hooks/useMetricInfo';
import { useSelector } from 'react-redux';
import { AnalyticCard } from '../AnalyticCard';
import { GLOBAL_WHATSAPP_CARD_IDS, GLOBAL_WHATSAPP_CARD_TEXT } from './constants';
import { createWhatsAppMetricsByName } from './utils';
import { WhatsAppAnalyticTable } from './WhatsAppAnalyticTable';

export const WhatsAppUsageCard = () => {
  const {
    isLoading,
    billingPeriodMetrics: { ByOrgWhatsAppTemplateCategory = [] } = {},
  } = useQueryContext();
  const { BillingWhatsAppReporting, WhatsAppMessageChannelGA } = useSelector(selectFeatureFlags);
  const isWhatsAppEnabled = BillingWhatsAppReporting && WhatsAppMessageChannelGA;
  const whatsAppMetrics = ByOrgWhatsAppTemplateCategory?.[0] || [];
  const whatsAppMetricsByName = createWhatsAppMetricsByName(whatsAppMetrics);

  const [whatsAppMarketingInfo, whatsAppUtilityInfo] = useMetricInfo(
    ['whatsAppMarketing', 'whatsAppUtility'],
    whatsAppMetricsByName,
  );

  const cardMetrics = [
    {
      metricName: GLOBAL_WHATSAPP_CARD_TEXT.utilityMessagesName,
      metricValue: whatsAppUtilityInfo.value,
      timePeriod: whatsAppUtilityInfo.dateRangeText,
    },
    {
      metricName: GLOBAL_WHATSAPP_CARD_TEXT.marketingMessagesName,
      metricValue: whatsAppMarketingInfo.value,
      timePeriod: whatsAppMarketingInfo.dateRangeText,
    },
  ];

  return (
    <>
      {isWhatsAppEnabled && (
        <AnalyticCard
          data-test={GLOBAL_WHATSAPP_CARD_IDS.cardId}
          isLoading={isLoading}
          metrics={cardMetrics}
          title={GLOBAL_WHATSAPP_CARD_TEXT.cardTitle}
        >
          <WhatsAppAnalyticTable />
        </AnalyticCard>
      )}
    </>
  );
};
